var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.133,
    height: 17.815,
    viewBox: "0 0 16.133 17.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#11232e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#00a0e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.181,6h11.77a1.672,1.672,0,0,1,1.681,1.663V19.307a1.672,1.672,0,0,1-1.681,1.663H6.181A1.672,1.672,0,0,1,4.5,19.307V7.663A1.672,1.672,0,0,1,6.181,6Z",
    transform: "translate(-4.5 -4.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,3V6.689",
    transform: "translate(-13.071 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,3V6.689",
    transform: "translate(-7.796 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.988,7.889,7.653,5.554a1.48,1.48,0,0,0-1.7-.277L3.825,3.152V1.914L1.273,0,0,1.276,1.911,3.828H3.149L5.275,5.953a1.483,1.483,0,0,0,.277,1.7L7.886,9.99a.741.741,0,0,0,1.051,0L9.988,8.939a.745.745,0,0,0,0-1.051ZM6.61,4.486A2.1,2.1,0,0,1,8.1,5.1l.387.387A2.822,2.822,0,0,0,9.364,4.9a2.867,2.867,0,0,0,.756-2.725.239.239,0,0,0-.4-.11L8.235,3.551,6.881,3.325,6.656,1.972,8.139.488a.241.241,0,0,0-.114-.4A2.872,2.872,0,0,0,5.3.841a2.825,2.825,0,0,0-.821,2.065L6.118,4.543a2.172,2.172,0,0,1,.492-.058ZM4.539,6.12,3.409,4.99.37,8.03a1.276,1.276,0,0,0,1.8,1.8L4.639,7.37a2.141,2.141,0,0,1-.1-1.25ZM1.273,9.41a.478.478,0,1,1,.478-.478A.48.48,0,0,1,1.273,9.41Z",
    transform: "translate(2.628 5.092)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.5de8ad7baaf2a6a19f31c484baf408ad.svg";
export { ForwardRef as ReactComponent };